import type { GuidedBuildDefinition, GuidedBuildPreview } from "./api.js";

export function GuidedBuildStep({
  definition,
  answers,
  preview,
  originId,
  selectedPowerIds,
  busy,
  onAnswer,
  onOrigin,
  onPower,
  onGenerate,
}: {
  definition: GuidedBuildDefinition;
  answers: Record<string, string>;
  preview: GuidedBuildPreview | null;
  originId: string;
  selectedPowerIds: string[];
  busy: boolean;
  onAnswer: (questionId: string, answerId: string) => void;
  onOrigin: (originId: string) => void;
  onPower: (powerId: string) => void;
  onGenerate: () => void;
}) {
  const completed = definition.questions.filter((question) => answers[question.id]).length;
  return <div className="guided-build">
    <div className="guided-progress"><strong>{completed}/{definition.requiredAnswerCount}</strong><span>answers complete</span></div>
    {definition.origins.length > 1 && <section className="question-card">
      <p className="eyebrow">ORIGIN</p><h2>How did this yōkai come into being?</h2>
      <div className="answer-grid">{definition.origins.map((origin) => <button type="button" key={origin.id} className={originId === origin.id ? "selected" : ""} onClick={() => onOrigin(origin.id)}><strong>{origin.label}</strong>{origin.description && <span>{origin.description}</span>}</button>)}</div>
    </section>}
    {definition.questions.map((question, index) => <section className="question-card" key={question.id}>
      <p className="eyebrow">QUESTION {String(index + 1).padStart(2, "0")}</p><h2>{question.prompt}</h2>
      <div className="answer-grid">{question.answers.map((answer) => <button type="button" key={answer.id} className={answers[question.id] === answer.id ? "selected" : ""} onClick={() => onAnswer(question.id, answer.id)}>{answer.label}</button>)}</div>
    </section>)}
    <div className="generator-action"><button type="button" className="primary" disabled={busy || completed !== definition.requiredAnswerCount} onClick={onGenerate}>{preview ? "Regenerate specialized build" : "Generate specialized build"}</button></div>
    {preview && <section className="generated-profile">
      <p className="eyebrow">YOUR BUILD</p><h2>{preview.profile.generalSkillLabel} · {preview.profile.attributeLabel}</h2><p>{preview.profile.explanation}</p>
      <dl><div><dt>Attribute focus</dt><dd>{preview.profile.attributeLabel}</dd></div><div><dt>Group role</dt><dd>{preview.profile.generalSkillLabel}</dd></div><div><dt>Monstrous style</dt><dd>{preview.profile.monstrousSkillLabel}</dd></div><div><dt>Arcane theme</dt><dd>{preview.profile.powerThemeLabel}</dd></div></dl>
      <h3>Choose exactly three Arcane Powers</h3>
      <div className="power-grid">{preview.powerShortlist.map((power) => {
        const selected = selectedPowerIds.includes(power.id);
        return <button type="button" key={power.id} className={selected ? "power-choice selected" : "power-choice"} onClick={() => onPower(power.id)}><strong>{power.label}</strong><span>{power.sphere_id.replace("sphere.", "")}{power.fear_cost != null ? ` · ${power.fear_cost} Fear` : ""}</span></button>;
      })}</div>
      <div className="selection-count">{selectedPowerIds.length}/3 Powers selected</div>
    </section>}
  </div>;
}
